'use client';

import { useState, useEffect } from "react";

export default function PrivacyPolicyPage() {
    const [lastUpdated, setLastUpdated] = useState('');

    useEffect(() => {
        setLastUpdated(new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }));
    }, []);

    if (!lastUpdated) {
        return null;
    }

    return (
        <>
            <section className="bg-secondary pt-12">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl md:text-5xl font-bold font-headline text-foreground">Privacy Policy</h1>
                    <p className="mt-4 text-lg text-muted-foreground">Last Updated: {lastUpdated}</p>
                </div>
            </section>
            <section className="py-16">
                <div className="container mx-auto px-4 max-w-3xl prose dark:prose-invert lg:prose-lg">
                    <h2>1. Introduction</h2>
                    <p>Welcome to Upbeat Brain Game. We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy outlines how we collect, use, and protect your information when you use our website and services.</p>
                    
                    <h2>2. Information We Collect</h2>
                    <p>We may collect the following types of information:</p>
                    <ul>
                        <li><strong>Personal Information:</strong> When you book a demo or contact us, you may provide us with personal information such as your name, email address, phone number, and your child's name and age.</li>
                        <li><strong>Usage Data:</strong> We automatically collect information on how you interact with our website. This may include your IP address, browser type, pages visited, and the time and date of your visit. We use tools like Google Analytics for this purpose.</li>
                        <li><strong>Booking Information:</strong> When you schedule a demo through our Calendly integration, Calendly collects information to process the booking. We recommend reviewing Calendly's privacy policy.</li>
                    </ul>

                    <h2>3. How We Use Your Information</h2>
                    <p>We use the information we collect for various purposes, including:</p>
                    <ul>
                        <li>To provide and maintain our services.</li>
                        <li>To schedule and conduct demo classes.</li>
                        <li>To communicate with you, including responding to your inquiries and sending you information about our programs.</li>
                        <li>To improve our website and services by analyzing usage data.</li>
                        <li>To comply with legal obligations.</li>
                    </ul>

                    <h2>4. Data Sharing and Disclosure</h2>
                    <p>We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties. This does not include trusted third parties who assist us in operating our website or conducting our business (like Calendly and Google Analytics), so long as those parties agree to keep this information confidential. We may also release your information when we believe release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property, or safety.</p>

                    <h2>5. Data Security</h2>
                    <p>We implement a variety of security measures to maintain the safety of your personal information. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems and are required to keep the information confidential.</p>

                    <h2>6. Your Rights</h2>
                    <p>You have the right to access, correct, or delete your personal information. If you wish to exercise these rights, please contact us at the email address provided below. In some jurisdictions, such as the EEA, you may have additional rights under the General Data Protection Regulation (GDPR).</p>

                    <h2>7. Changes to This Privacy Policy</h2>
                    <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.</p>
                    
                    <h2>8. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy, please contact us at:</p>
                    <p>Email: <a href="mailto:upbeatbraingame@gmail.com">upbeatbraingame@gmail.com</a></p>
                </div>
            </section>
        </>
    );
}
